export const URL_STARSHIPS = 'https://swapi.dev/api/starships/';
export const URL_PEOPLE = 'https://swapi.dev/api/people/';
